module.exports = __webpack_public_path__ + "img/condominio-1.52175a95.png";